import { createContext, useContext, useState } from 'react';

const CollectionContext = createContext();

export const useCollection = () => {
	const context = useContext(CollectionContext);
	if (!context) {
		throw new Error('useCollection must be used within a CollectionProvider');
	}
	return context;
};

export const CollectionProvider = ({ children }) => {
	const [collection, setCollection] = useState([]);

	const addToCollection = (item) => {
		setCollection(prev => [...prev, item]);
	};

	const removeFromCollection = (itemId) => {
		setCollection(prev => prev.filter(item => item.id !== itemId));
	};

	const updateCollection = (newCollection) => {
		setCollection(newCollection);
	};

	return (
		<CollectionContext.Provider value={{
			collection,
			addToCollection,
			removeFromCollection,
			updateCollection
		}}>
			{children}
		</CollectionContext.Provider>
	);
};

export default CollectionContext; 